import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'antim-autoware-page-title',
  standalone: false,
  templateUrl: './page-title.component.html',
  styleUrl: './page-title.component.scss'
})
export class PageTitleComponent {

  @Input() pageTitle = "";
  @Input() pageBreadcrumb: any = [];
  @Input() redirectTo = "";
  constructor(private router: Router) { }
  redirect() {
    this.router.navigate([`${this.redirectTo}`]);
  }
}

